module.exports = __webpack_public_path__ + "static/img/best_game.2df62398.png";